import styled, { Color, BorderRadius, Spacing, css, Breakpoint, Font } from '@nfinite/react-hubstairs/styled'

const SPACINGS_INPUT = {
  s: 'xs',
  sm: 'xs',
  m: 'm',
  default: 'm',
}

const SPACINGS_SIDE_ELEMENTS = {
  s: 'xs',
  sm: 'xs',
  m: 'l',
  default: 'l',
}
const SPACINGS_SIDE_ELEMENTS_MOBILE = {
  s: 'xs',
  sm: 'xs',
  m: 'm',
  default: 'm',
}

const SIZES_SIDE_ELEMENTS = {
  s: 15,
  sm: 15,
  m: 20,
  default: 25,
}

const INPUT_HEIGHTS = {
  s: 30,
  sm: 40,
  m: 50,
  default: 50,
}

const INPUT_FONT_SIZES = {
  s: 'xs',
  sm: 's',
  m: 'default',
  default: 'default',
}

const INPUT_RADIUS = {
  s: 's',
  sm: 's',
  m: 'm',
  default: 'm',
}

const disabledStyle = css`
  border: 1px solid ${Color.get('transparent')};
  color: ${Color.get('text', 'gray')};
  cursor: initial;
`

const getErrorStyle = ({ hasError }) =>
  hasError &&
  css`
    border-color: ${Color.get('alert')};
  `

const getHorizontalSpacing = ({ hasLeft, hasRight, size, outerRightWidth, innerLeftWidth }) => css`
  padding-left: ${({ theme }) =>
    `${
      theme.getSpacing(SPACINGS_INPUT[size]) +
      (hasLeft ? innerLeftWidth + SIZES_SIDE_ELEMENTS[size] + theme.getSpacing(SPACINGS_SIDE_ELEMENTS_MOBILE[size]) : 0)
    }px`};
  padding-right: ${({ theme }) =>
    `${
      theme.getSpacing(SPACINGS_INPUT[size]) +
      (hasRight
        ? outerRightWidth + SIZES_SIDE_ELEMENTS[size] + theme.getSpacing(SPACINGS_SIDE_ELEMENTS_MOBILE[size])
        : 0)
    }px`};
`
const getRightHorizontalSpacing = ({ hasRight, size }) => css`
  padding-left: 0px;
  padding-right: ${({ theme }) => `${hasRight ? SIZES_SIDE_ELEMENTS[size] : theme.getSpacing(SPACINGS_INPUT[size])}px`};
`

export const Container = styled('div')`
  position: relative;
  height: ${({ size }) => `${INPUT_HEIGHTS[size]}px`};
  width: 100%;
`

export const InputField = styled('input')`
  height: 100%;
  width: 100%;
  color: ${Color.get('text')};

  background-color: ${Color.get('gray', 'light')};
  border: 1px solid ${Color.get('gray', 'light')};
  ${BorderRadius.generate({ all: 'm' })}
  ${({ size }) => Font.generate({ size: INPUT_FONT_SIZES[size] })};
  ${({ size }) => BorderRadius.generate({ all: INPUT_RADIUS[size] })};
  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `}

  &:hover {
    border-color: ${Color.get('gray', 'dark')};
  }

  &:focus,
  &:active {
    outline: none;
    border-color: ${Color.get('secondary')};
  }

  ::placeholder {
    ${({ placeholderColor }) =>
      placeholderColor
        ? css`
            color: ${Color.get(placeholderColor)};
          `
        : css`
            color: ${Color.get('gray', 'dark')};
          `}
  }

  :disabled,
  :read-only {
    ${disabledStyle}
  }

  ${getErrorStyle}

  ${({ hasRightSpacing }) => (hasRightSpacing ? getRightHorizontalSpacing : getHorizontalSpacing)}

  /* Chrome, Safari, Edge, Opera */
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`

export const Left = styled('div')`
  ${({ size, innerLeftWidth }) => css`
    width: ${innerLeftWidth + SIZES_SIDE_ELEMENTS[size]}px;
    height: ${SIZES_SIDE_ELEMENTS[size]}px;
    ${Spacing.generateMargin({ left: SPACINGS_SIDE_ELEMENTS_MOBILE[size] })}
    ${Breakpoint.greaterThanMobile()} {
      ${Spacing.generateMargin({ left: SPACINGS_SIDE_ELEMENTS[size] })}
    }
  `}
`

Left.Container = styled('div')`
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const Right = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  ${({ size, hasRightSpace, outerRightWidth }) =>
    hasRightSpace
      ? css`
          width: ${SIZES_SIDE_ELEMENTS[size] + outerRightWidth}px;
          height: ${SIZES_SIDE_ELEMENTS[size]}px;
          ${Font.generate({ size: INPUT_FONT_SIZES[size] })}
          ${Spacing.generateMargin({ right: SPACINGS_SIDE_ELEMENTS_MOBILE[size] })}
      ${Breakpoint.greaterThanMobile()} {
            ${Spacing.generateMargin({ right: SPACINGS_SIDE_ELEMENTS[size] })}
          }
        `
      : css`
          width: ${SIZES_SIDE_ELEMENTS[size]}px;
          height: ${SIZES_SIDE_ELEMENTS[size]}px;
          ${Font.generate({ size: INPUT_FONT_SIZES[size] })}
        `}
`

Right.Container = styled('div')`
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`
